import { create } from 'zustand'

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
  error?: boolean
}

// Drawer width (px), persisted across sessions and shared so the layout can reserve
// space for the drawer instead of letting it overlap page content.
export const MIN_CHAT_WIDTH = 340
const initialChatWidth = (() => {
  const saved = Number(localStorage.getItem('qtz-chat-width'))
  return saved >= MIN_CHAT_WIDTH ? saved : 400
})()

interface ChatState {
  isOpen: boolean
  width: number
  messages: ChatMessage[]
  open: () => void
  close: () => void
  toggle: () => void
  setWidth: (w: number) => void
  addMessage: (m: ChatMessage) => void
  updateLast: (content: string, error?: boolean) => void
  clear: () => void
}

// Session-scoped state for the global assistant drawer (width persisted).
export const useChatStore = create<ChatState>((set) => ({
  isOpen: false,
  width: initialChatWidth,
  messages: [],
  setWidth: (w) => set({ width: w }),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  addMessage: (m) => set((s) => ({ messages: [...s.messages, m] })),
  updateLast: (content, error = false) =>
    set((s) => {
      const messages = [...s.messages]
      if (messages.length) messages[messages.length - 1] = { role: 'assistant', content, error }
      return { messages }
    }),
  clear: () => set({ messages: [] }),
}))
